var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back",style:(`${_vm.isBackDisabled ? 'display: none' : ''}`),on:{"click":_vm.go_back,"touchstart":function($event){$event.stopPropagation();return _vm.startDrag.apply(null, arguments)}}},[(!_vm.isKunhua)?_c('img',{attrs:{"src":"/static/img/tip.png","alt":""}}):_c('img',{attrs:{"src":"/static/img/tip_kunhua.png","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }